<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $t("cardtype") }}</div>
      <div>
        <router-link class="btn-blue" to="card-type"
          >{{ $t("cardtype") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                name="card_type"
                v-validate="{ required: 'required' }"
                id="card_type"
                v-model="cardDetails.card_type"
              />
              <label>{{ $t("cardtype") }}</label>
            </div>
            <!-- <Tooltip :title="$t('enterCardType')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('card_type')">{{
              errors.first("card_type")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.bank.length > 0 ? 'shift-up' : 'd-none'"
              >{{ $t("select") }} {{ $t("bank") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.bank" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(bank,bankIndex) in banks"
                  :key="bankIndex"
                  @click="onSelectHandler('bank',bank)"
                  name="bank"
                  id="bank"
                >{{ bank.bank_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="banks"
                :searchable="true"
                :placeholder="
                  selected.bank && selected.bank.length > 0
                    ? selected.bank
                    : $tc('selectBank')
                "
                label="bank_name"
                track-by="bank_id"
                @select="onSelectHandler('bank', $event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <!-- <Tooltip :title="$t('enterbankname')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.bank.length == 0"
                >Please select bank.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="cardDetails.card_is_active"
                  unchecked-value="N"
                  value="Y"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="card-type">{{
            $t("cancel")
          }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { METHODS } from "http";
export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      selected: {
        bank: "",
      },
      cardDetails: {
        bank_id: "",
        card_type: "",
        card_is_active: "N",
      },
      bank_id: "",
      bank_name: "",
      banks: [],
      bankMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_banks",
        urlKey: "banks",
      },
    };
  },
  beforeMount() {
    this.getBankList();
  },
  methods: {
    onResetForm: function () {
      this.bank_id = null;
      ((this.cardDetails.card_is_active = "N"),
      (this.cardDetails.card_type = null)),
        (this.selected = {
          bank: "",
        });
    },
    getBankList: function () {
      this.banks = [];
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (this.cardDetails.bank_id.length == 0) {
          return;
        }
        if (valid) {
          this.btenable = true;
          MarketingService.addCardType({ ...this.cardDetails })
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);
                this.onResetForm();
                if (redirect) {
                  // console.log("redirect value ", redirect);
                  this.$router.push({
                    path: "/marketing/card-type",
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
    onSelectHandler: function (type, value) {
      if (type == "bank") {
        this.cardDetails.bank_id = value.bank_id;
        this.selected.bank = value.bank_name;
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CardTypeComponents/addCardType.vue